export default __webpack_public_path__ + "static/px8-f8b966f0cd8af70ce02126970339ebd8.jpg";